module.exports = __webpack_public_path__ + "img/train-wheels-02.db4bab39.png";